"use client";
import BlogCard from "@/components/Blog/BlogCard";
import { scrollToResults } from "@/components/Blog/BlogSearch/utils";
import { BLOG_INDEX_URL } from "@/data/helpers/blog/urls";
import { BlogPost } from "@/types/search";
import { Paragraph } from "@cgc/ui/typography";
import Link from "next/link";
import { useHits, useMenu } from "react-instantsearch";

const BlogSearchResults = () => {
  const { hits, results } = useHits<BlogPost>();
  const { refine } = useMenu({ attribute: "tag" });

  if (hits.length === 0) {
    return (
      <div className="p-10 text-center">
        <Paragraph size="sub2" className="uppercase">
          We’re sorry! No results found for ‘{results?.query}’.
        </Paragraph>
        <Paragraph>
          You can search for something else, or just{" "}
          <Link href={BLOG_INDEX_URL}>browse the blog</Link>!
        </Paragraph>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {hits.map((post) => (
        <BlogCard
          key={post.uid}
          title={post.title}
          image={post.image}
          pubDate={post.last_publication_date}
          tags={post.tag}
          link={post.url}
          onTagClick={(tag: string) => {
            refine(tag);
            scrollToResults();
          }}
        />
      ))}
    </div>
  );
};

export default BlogSearchResults;
